import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/public/form/submit/67a5e0e0-e0e0-4e0e-8e0e-0e0e0e0e0e02', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-500 to-teal-600 text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-20 py-12 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16">
          <div>
            <h3 className="text-xl md:text-2xl font-light mb-4 md:mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              MB Óticas
            </h3>
            <p className="text-white/80 text-sm leading-relaxed">
              Transformando a forma como você enxerga o mundo desde 1990.
            </p>
          </div>

          <div>
            <h4 className="font-medium mb-3 md:mb-4">Links Rápidos</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#home" className="text-white/80 hover:text-white transition-colors cursor-pointer">Home</a></li>
              <li><a href="#produtos" className="text-white/80 hover:text-white transition-colors cursor-pointer">Produtos</a></li>
              <li><a href="#servicos" className="text-white/80 hover:text-white transition-colors cursor-pointer">Serviços</a></li>
              <li><a href="#sobre" className="text-white/80 hover:text-white transition-colors cursor-pointer">Sobre</a></li>
              <li><a href="#contato" className="text-white/80 hover:text-white transition-colors cursor-pointer">Contato</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-3 md:mb-4">Contato</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                (11) 93472-8670
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                mb.oticascontato@gmail.com
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>Rua Delfino Facchina, 1145<br />São Paulo, Brazil</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-3 md:mb-4">Newsletter</h4>
            <p className="text-white/80 text-sm mb-4">
              Receba novidades e promoções exclusivas
            </p>
            <form onSubmit={handleNewsletterSubmit} className="space-y-3" data-readdy-form id="newsletter-form">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Seu e-mail"
                required
                className="w-full px-4 py-3 rounded-lg text-sm text-gray-800 focus:outline-none"
              />
              {submitStatus === 'success' && (
                <p className="text-white text-xs">Inscrito com sucesso!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-200 text-xs">Erro ao inscrever. Tente novamente.</p>
              )}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-white text-teal-600 px-4 py-3 rounded-lg text-sm font-medium hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
              >
                {isSubmitting ? 'Enviando...' : 'Inscrever-se'}
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/60 text-xs md:text-sm text-center md:text-left">
            © 2026 MB Óticas. Todos os direitos reservados.
          </p>
          
          <div className="flex items-center gap-4 md:gap-6">
            <a 
              href="https://wa.me/5511934728670" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
            </a>
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a 
              href="https://facebook.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-facebook-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}